import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import JobRunDto from "../classes/dtos/jobmodule/JobRunDto";
import { JobStatusDto } from "../classes/dtos/jobmodule/JobStatusDto";
import { IJobResumeDto } from "../classes/dtos/jobmodule/IJobResumeDto";
import PathType from "../consts/pathmodule/PathType";
import PathSynchroJobResumeDto from "../classes/dtos/jobmodule/PathSynchroJobResumeDto";
import PathJobResumeGroupDto from "../classes/dtos/jobmodule/PathJobResumeGroupDto";
import PathJobResumeDetailDto from "../classes/dtos/jobmodule/PathJobResumeDetailDto";
import PathReportingJobResumeDto from "../classes/dtos/jobmodule/PathReportingJobResumeDto";
import PathMetaApiReadJobResumeDto from "../classes/dtos/jobmodule/PathMetaApiReadJobResumeDto";
import PathAIJobResumeDto from "../classes/dtos/jobmodule/PathAIJobResumeDto";

const JobApi = {

    GetRunListAsync: async function (begin: Date | null, end: Date | null): Promise<ProcessingResult<JobRunDto[]>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Job/GetRunList", {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.runs.map((e: any) => new JobRunDto(e.id, e.name, e.pathId, e.pathTypeId, e.pathTypeLabel, e.pathDeleted, new Date(e.start), e.end != null ? new Date(e.end) : null, new JobStatusDto(e.status,(e.resume?.ignored ?? null) !== null && e.resume.ignored > 0), e.progress, this.ToResumeDto(e.pathTypeId, e.resume))));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    ToResumeDto: function (pathType: number, values: any | null): IJobResumeDto | null{

        if (values === null) {
            return null;
        }

        switch (pathType) {
            case PathType.DataSynchronization:
                {
                    let groups = values.groups.map((e: any) => new PathJobResumeGroupDto(e.label, e.count, e.details.map((x: any) => new PathJobResumeDetailDto(x.scope, x.type, x.level, x.details))));
                    return new PathSynchroJobResumeDto(values.toAdd, values.toUpdate, values.toDelete, values.toIgnore, values.added, values.updated, values.deleted, values.ignored, groups);
                }
            case PathType.Reporting:
                return new PathReportingJobResumeDto(values.rowCount);
            case PathType.MetaApi:
                return new PathMetaApiReadJobResumeDto(values.rowCount);
            case PathType.AI:
                return new PathAIJobResumeDto(values.rowCount);
        }

        return null;
    }
};

export default JobApi;